import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static get targets () {
		return ['view', 'clear', 'input'];
	}

	viewTargetConnected(element) {
		element.addEventListener('click', () => {
			if (this.hasInputTarget) {
				this.inputTarget.type = this.inputTarget.type === 'password' ? 'text' : 'password';
				element.classList.toggle('is-active');
			}
		});
	}

	inputTargetConnected(element) {
		element.addEventListener('input', () => {
			const value = element.value;

			if (this.hasClearTarget) {
				this.clearTarget.classList.toggle('is-active', value.length > 0);
			}
		});
	}

	clearTargetConnected(element) {
		element.addEventListener('click', () => {
			if (this.hasInputTarget) {
				this.inputTarget.value = '';
				this.inputTarget.dispatchEvent(new Event('input'));
			}
		});
	}
}
